module.exports = __webpack_public_path__ + "static/media/img133.ecbc4eb8.jpg";